module.exports = __webpack_public_path__ + "assets/facebook-dc659e.svg";